<div class="accordion" [ngStyle]="style">
  <div
    class="accordion-header"
    (click)="toggleAccordion()" role="button"  tabindex="-1"
    [ngStyle]="headerStyle"
  >

  <ng-container *ngIf="customHeaderTemplate; else defaultHeader">
    <ng-container *ngTemplateOutlet="customHeaderTemplate"></ng-container>
  </ng-container>
  <ng-template #defaultHeader>
    <span class="accordion-title">{{ title }}</span>
  </ng-template>
  <i class="accordion-icon pi pi-chevron-down ms-2" [class.open]="isOpen" *ngIf="referenceContent.children.length !== 0"></i>
  </div>

  <div
    class="accordion-content"
    [ngStyle]="contentStyle"
    [class.open]="isOpen && referenceContent.children.length !== 0"
  #referenceContent>
    <ng-content></ng-content>
  </div>
</div>
